import { gql } from "@apollo/client";
import moment from 'moment';

const faseMap = {
    295: 0,
    296: 1,
    297: 2,
    298: 3
};
const GET_VISITAS_COORDINACION = gql`
    query GetVisitasCoordinacion($input: GetVisitasControlFiltersInput!) {
        visitasCoordinacion(input: $input) {        
        idVisita
        idVisitaClone
        idProfesional
        idTipoProfesional
        idFiguraProfesional
        idEvaluacion
        idFrecuencia
        fechaVisita
        fechaAlta
        fechaFin
        fechaFinUsuario
        codigoAtencion
        capacitacion
        desdeCoordinacion
        periodo
        visitaHonorario {
            presencial
            virtual
            tramo
            capacitacion
            cambioSonda
            emergencia
            extraDuracion
            importeTotal
        }
        idEvaluacionNavigation {
            idPaciente
            idTipoModuloNavigation {
                idTipoModulo
                abreviacion
            }
        }
        idProfesionalNavigation {
            idFuncion
            idTipoProfesional
        }
        idUsuarioValidadorNavigation {
            nombre
            apellido
        }
        fechaValidacion
        observacionRechazo
        idUsuarioAnuladorNavigation {
            nombre
            apellido
        }
        fechaAnulacion
        observacionAnulacion
        idUsuarioModificacion 
        idUsuarioModificacionNavigation {
            nombre
            apellido
        }
        fechaModificacion
        idEstadoCoordinacionVisitaNavigation {
            descripcion
        }
        idComboVisitaValorFormaVisitaNavigation {
            idComboVisitaValor
            valor
        }
        idComboVisitaValorTipoVisitaNavigation {
            idComboVisitaValor
            valor
        }
        idFiguraProfesionalNavigation {
            descripcion
        }
        idComboVisitaValorPacienteDomicilio
        idFase
    }
}`;

export default GET_VISITAS_COORDINACION;

export const adaptVisitasCoordinacion = (data) => {
    if (!data) return [];

    //ahora construimos logicamente una nueva prop que le indica a una visita de profesional
    //si fue clonada y tiene una visita coordinacion hija
    const idVisitasCloneMap = new Map(
        data.visitasCoordinacion
            .filter(v => !!v.idVisitaClone)
            .map(v => [v.idVisitaClone, v.idVisita])
    );

    return data.visitasCoordinacion.map(visita => (
        {
            ...visita,
            programa: visita.idEvaluacionNavigation?.idTipoModuloNavigation?.abreviacion,
            idTipoModulo: visita.idEvaluacionNavigation?.idTipoModuloNavigation?.idTipoModulo || null,
            idPaciente: visita.idEvaluacionNavigation?.idPaciente || null,
            estado: visita.idEstadoCoordinacionVisitaNavigation?.descripcion || '',
            horaIngreso: moment(visita.fechaVisita).format('DD/MM/YYYY HH:mm'),
            horaEgreso: !!visita?.fechaFinUsuario ? moment(visita.fechaFinUsuario).format('DD/MM/YYYY HH:mm') : '-',
            tiempoTotal: visita?.fechaFinUsuario
                ? (() => {
                    const totalMinutes = Math.round(moment(visita.fechaFinUsuario).diff(moment(visita.fechaVisita), 'minutes', true));
                    const horas = Math.floor(totalMinutes / 60);
                    const minutos = totalMinutes % 60;
                    return `${horas}h ${minutos}min`;
                })()
                : '-',
            fechaVisita: visita.fechaVisita,
            fechaAlta: visita.fechaAlta,
            fechaFin: !!visita?.fechaFinUsuario ? visita.fechaFinUsuario : '-',
            fechaFinUsuario: !!visita?.fechaFinUsuario ? visita.fechaFinUsuario : '-',
            forma: visita.idComboVisitaValorFormaVisitaNavigation?.valor || '',
            idComboVisitaValorFormaVisita: visita.idComboVisitaValorFormaVisitaNavigation?.idComboVisitaValor || null,
            tipo: visita.idComboVisitaValorTipoVisitaNavigation?.valor || '',
            idTipoVisita: visita.idComboVisitaValorTipoVisitaNavigation?.idComboVisitaValor || null,
            idFuncionProfesional: visita.idProfesionalNavigation?.idFuncion || null,
            idProfesional: visita?.idProfesional,
            idTipoProfesional: visita?.idTipoProfesional,
            idFiguraProfesional: visita?.idFiguraProfesional,
            capacitacion: visita?.capacitacion,
            periodo: visita?.periodo,
            desdeCoordinacion: visita?.desdeCoordinacion,
            usuarioAnulador: `${visita?.idUsuarioAnuladorNavigation?.apellido || ""} ${visita?.idUsuarioAnuladorNavigation?.nombre || ""}`,
            usuarioValidador: `${visita?.idUsuarioValidadorNavigation?.apellido || ""} ${visita?.idUsuarioValidadorNavigation?.nombre || ""}`,
            usuarioModificador: (!!visita?.idUsuarioModificacionNavigation?.apellido ? visita?.idUsuarioModificacionNavigation?.apellido : "") + " " +
                (!!visita?.idUsuarioModificacionNavigation?.nombre ? visita?.idUsuarioModificacionNavigation?.nombre : " "),
            modificada: !!visita.idVisitaClone || !!visita?.idUsuarioModificacionNavigation?.nombre ? "SI" : "NO",
            idVisitaChild: idVisitasCloneMap.get(visita.idVisita) || null,
            figuraProfesional: visita.idFiguraProfesionalNavigation?.descripcion || '',
            extraDuracion: visita.visitaHonorario?.at()?.extraDuracion || 0,
            idFase: faseMap[visita?.idFase] ?? null,
        }));
}
